import React, { useEffect, useState } from "react";
import { supabase } from "./supabaseClient";
import { banPlayerInPlayFab } from "./playfabClient"; // ✅ Correct import

function App() {
  const [reports, setReports] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchReports();
  }, []);

  // ✅ Fetch only "Pending" reports
  const fetchReports = async () => {
    setLoading(true);
    let { data, error } = await supabase
      .from("player_reports")
      .select("*")
      .eq("status", "Pending") // ✅ Fetch only Pending reports
      .order("report_timestamp", { ascending: true });

    if (error) {
      console.error("❌ Error fetching reports:", error.message);
    } else {
      setReports(data);
    }
    setLoading(false);
  };

  // ✅ Handle Ban Action
  const handleAction = async (reportId, playfabId) => {
    try {
      const duration = prompt("Enter ban duration in hours:", "99999");
      if (!duration || isNaN(duration) || duration <= 0) {
        alert("Invalid duration. Please enter a positive number.");
        return;
      }

      await banPlayerInPlayFab(playfabId, Number(duration));

      const { error } = await supabase
        .from("player_reports")
        .update({ status: "Reviewed" }) // ✅ Update status to "Reviewed"
        .eq("report_id", reportId);

      if (error) {
        console.error("❌ Error updating report:", error.message);
      } else {
        alert(`✅ Report ${reportId} reviewed and Player ${playfabId} banned for ${duration} hours.`);
        fetchReports(); // ✅ Refresh only "Pending" reports
      }
    } catch (error) {
      console.error("❌ Error banning player:", error);
    }
  };

  return (
    <div style={{ padding: "20px", fontFamily: "Arial, sans-serif" }}>
      <h2>📜 Player Reports Dashboard (Pending Only)</h2>
      {loading ? <p>Loading reports...</p> : (
        <table border="1" cellPadding="8" cellSpacing="0" width="100%">
          <thead>
            <tr>
              <th>ID</th>
              <th>Reporter</th>
              <th>Reported Player</th>
              <th>Category</th>
              <th>Game Session</th>
              <th>Timestamp</th>
              <th>Description</th>
              <th>Status</th>
              <th>Total Reports</th>
              <th>Action</th>
            </tr>
          </thead>
          <tbody>
            {reports.length === 0 ? (
              <tr><td colSpan="9" style={{ textAlign: "center" }}>No pending reports</td></tr>
            ) : (
              reports.map((report) => (
                <tr key={report.report_id}>
                  <td>{report.report_id}</td>
                  <td>{report.reporter_display_name} ({report.reporter_playfab_id})</td>
                  <td>{report.reported_display_name} ({report.reported_playfab_id})</td>
                  <td>{report.category_id}</td>
                  <td>{report.game_session_id}</td>
                  <td>{new Date(report.report_timestamp).toLocaleString()}</td>
                  <td>{report.description}</td>
                  <td>{report.status}</td>
                  <td>{report.report_count || 1}</td>
                  <td>
                    <button onClick={() => handleAction(report.report_id, report.reported_playfab_id)}>
                      Ban & Mark Reviewed
                    </button>
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      )}
    </div>
  );
}

export default App;
